// extracted by mini-css-extract-plugin
export default {"App":"Results_App__KgMMS","App__row":"Results_App__row__51BEt","App__topRow":"Results_App__topRow__9DqWg","App__button":"Results_App__button__jWxqR"};